import { IAudioWithUrl, IEventRequestParams, S3ObjectMetadata } from './shared.dto';

abstract class IRolodexDAO {
    public abstract searchContacts(params: IRolodexContactsSearchParams): Promise<IRolodexContactDTO[]>;
    public abstract getContact(params: { contactId: number }): Promise<IRolodexContactDTO>;
    public abstract updateAttendeeMapping(params: IUpdateAttendeeRolodexMappingParams): Promise<void>;
    public abstract updateRolodexContact(params: TUpdateRolodexContactRequestParams): Promise<IRolodexContactDTO>;
}

interface IRolodexContactsSearchParams {
    firstName?: string;
    lastName?: string;
    email?: string;
}

interface IRolodexContactDTO {
    contactId: number;
    firstName: string;
    lastName: string;
    preferredName?: string;
    organizationName?: string;
    primaryEmail?: string;
    namePrefix?: string;
    middleName?: string;
    nameSuffix?: string;
    nameNotes?: string;
    namePhonetic?: string;
    title?: string;
    phoneDirect?: string;
    phoneMobile?: string;
    linkedinUrl?: string;
    activeStatus?: string;
    nameAudio?: IAudioWithUrl;
    vipFlag?: boolean;
}


type IUpdateAttendeeRolodexMappingParams = IEventRequestParams & {
    attendeeId: number;
    contactId: number | null;
};

type TUpdateRolodexContactRequestParams = Omit<IRolodexContactDTO, 'organizationName' | 'nameAudio'> & {
    nameAudio?: S3ObjectMetadata | null;
};

export {
    IRolodexDAO,
    IRolodexContactsSearchParams,
    IRolodexContactDTO,
    IUpdateAttendeeRolodexMappingParams,
    TUpdateRolodexContactRequestParams,
};
